import { createFileRoute } from '@tanstack/react-router'
import { StaffOverview } from '../../../../components/StaffOverview'

export const Route = createFileRoute('/desa/$slug/dashboard/')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <StaffOverview desaId={desaId} />
  },
})
